<template>
  <div class="card mb-3">
    <div class="card-header">
      <h5 class="mb-0">{{ translation_key.key }} <span class="badge text-bg-primary float-end"><i class="fas fa-tag me-2"></i>{{ translation_key.tag }}</span></h5>
    </div>
    <div class="list-group list-group-flush">
      <TranslationGroup  v-for="[locale, translations] in translation_groups"
                        :key="locale.locale"
                        :initial-translations="translations"
                        :locale="locale"
                        :scope="scope"
                        :translation_key="translation_key"
      />
    </div>
  </div>

</template>

<script>

    import Translation from "./Translation.vue"
    import TranslationGroup from "./TranslationGroup.vue"
    export default {
        name: "TranslationsEditor",
      components: {TranslationGroup, Translation},
      props: {
            translation_key: Object,
            translation_groups: Array,
            locales: Array,
            scope: Object
        }
    }
</script>